module.exports = __webpack_public_path__ + "static/media/athlete.7b1834cd.svg";